import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/surein-ai.svg'

export const SureinAI = withSvgProps(SvgComponent)
